import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useId, useState } from "react";
import { Ui } from "@silvertours/front-shared";
export var Tabs = function(param) {
    var onTabSelected = param.behavior.onTabSelected, content = param.content, rules = param.rules;
    // We'll use a random string to avoid any id collisions with other tab segments
    var tabGroup = "tabGroup-".concat(useId());
    var initialName = content && content.length ? content[0].name : "";
    var ref = useState(initialName), activeTabName = ref[0], setActiveTabName = ref[1];
    if (!content || content.length === 0) {
        return null;
    }
    var ref1 = rules || {}, _textStyle = ref1.textStyle, textStyle = _textStyle === void 0 ? Ui.RichTextStyle.Primary : _textStyle;
    var handleTabSelected = function(tabName) {
        setActiveTabName(tabName);
        onTabSelected(tabName);
    };
    return /*#__PURE__*/ _jsx(Ui.TabNavigation, {
        textStyle: textStyle,
        children: content.map(function(tab) {
            return /*#__PURE__*/ _jsx(Ui.TabButton, {
                behavior: {
                    onSelectTab: handleTabSelected
                },
                content: _object_spread_props(_object_spread({}, tab), {
                    tabGroup: tabGroup
                }),
                rules: {
                    activeTabName: activeTabName,
                    textStyle: textStyle
                }
            }, tab.position);
        })
    });
};
